import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { WhatsappCampaign } from '../../components/CreateCampaign_v2/WhatsappCampaign';
import { RouteConstants } from '@/features/router/RouteConstants';

export const CampaignsWhatsappCreateFlowV2: FC = () => {
  const history = useHistory();

  const handleExitToList = () => {
    history.push(RouteConstants.whatsappCampaigns);
  };

  return <WhatsappCampaign mode='create' onExitToList={handleExitToList} />;
};
